/* eslint-disable import/prefer-default-export */
/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import isNil from 'lodash/isNil';
import { EMPTY_FIELD_STRING_PLACEHOLDER } from './StringUtils';

/**
 * This class represents the utility functions for velocity of an aircraft.
 */
const KNOT_TO_MPH_RATIO = 1.1507794480235;

export const knotToMphString = (knots: number, toFixedDecimal = 2) => {
  if (isNil(knots)) {
    return EMPTY_FIELD_STRING_PLACEHOLDER;
  }

  return `${(knots * KNOT_TO_MPH_RATIO).toFixed(toFixedDecimal)} mph`;
};

export const knotToMphNumber = (knots: number, toFixedDecimal = 2) => {
  return parseFloat((knots * KNOT_TO_MPH_RATIO).toFixed(toFixedDecimal));
};

export const calculateTravelTimeSeconds = (distanceMiles: number, velocityKnots: number) => {
  return (distanceMiles / knotToMphNumber(velocityKnots)) * 3600;
};
